import 'twin.macro';
import React from 'react';
import Target from 'components/Icons/icons/Target';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function ObjectifIcon(props: IconProps) {
  return (
    <Target
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['taupe-quiet']};
          color: ${tagTextColor.mandarine};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
